<template>
  <el-dialog
    title="Same-day delivery combo portions log"
    :visible.sync="shouldShow"
    @close="closeEvent"
    width="40% !important"
  >
    <div v-if="logs.length">
      <div class="mt-2" v-for="(log, i) in logs" :key="i">
        <div>
          <p class="text-grey-tertiary">
            {{ formatDateAndTime(log.created_at, "do m, y,") }}
          </p>
          <p v-if="log.action_type === 'update'">
            Portions available in combo item
            <span class="text-bold">{{
              log.meal_combo_name ? log.meal_combo_name : "combo item"
            }}</span>
            were changed from
            <span class="text-bold">{{ log.previous_value }}</span> to
            <span class="text-bold"> {{ log.new_value }} </span>.
          </p>
          <p v-else-if="log.action_type === 'create'">
            <span class="text-bold">{{
              log.meal_combo_name ? log.meal_combo_name : "Combo item"
            }}</span>
            was created and all portions available were set.
          </p>
          <p v-else-if="log.action_type === 'delete'">
            <span class="text-bold">
              {{ log.meal_combo_name ? log.meal_combo_name : "Combo item" }}
            </span>
            was deleted.
          </p>
        </div>
        <div class="is-flex is-align-center user-details">
          <p
            class="name-ellipse is-flex is-align-center is-justify-center mr-2"
          >
            {{ log.user_name[0] }}
          </p>
          <p class="text-bold">{{ log.user_name }}</p>
        </div>
      </div>
    </div>

    <div class="text-grey-tertiary" v-else>
      No Same-day delivery combo portions log
    </div>
    <div v-if="hasMore">
      <el-button type="primary" @click="loadMore">See more</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "OneTimeMenuLog",
  props: {
    show: Boolean,
    logs: Array,
    page: Number,
    total: Number,
    perPage: Number,
  },
  data() {
    return {
      showSeeMore: true,
    };
  },
  computed: {
    shouldShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
    hasMore() {
      return this.page * this.perPage < this.total;
    },
  },
  methods: {
    closeEvent() {
      this.shouldShow = false;
    },
    loadMore() {
      this.$emit("see-more");
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  color: #21312a;
  font-weight: 600;
  font-size: 1.125rem;
  margin-bottom: 5px;
}

.user-details {
  border-bottom: 1px solid #e2e9e6;
  padding-bottom: 12px;
  margin-top: 10px;
}
.name-ellipse {
  width: 31.89px;
  height: 31.89px;
  background: #e5e9fc;
  border-radius: 100%;
  color: #7189ff;
  font-weight: 500;
  font-size: 1.079rem !important;
}

p {
  margin-bottom: 5px;
}
</style>
